import { useEffect, useState } from 'react';

import trexImage from '../../trex-dev.png';

interface ToastyProps {
  open: boolean;
  onDone: () => void;
}

const ENTER_ANIMATION_MS = 380;
const HOLD_MS = 1_200;
const LEAVE_ANIMATION_MS = 320;

type Phase = 'enter' | 'hold' | 'leave';

const Toasty = ({ open, onDone }: ToastyProps) => {
  const [mounted, setMounted] = useState(false);
  const [phase, setPhase] = useState<Phase>('enter');

  useEffect(() => {
    if (!open) {
      return;
    }

    setMounted(true);
    setPhase('enter');

    const enterTimeout = setTimeout(() => setPhase('hold'), ENTER_ANIMATION_MS);
    const leaveTimeout = setTimeout(() => setPhase('leave'), ENTER_ANIMATION_MS + HOLD_MS);
    const doneTimeout = setTimeout(() => {
      setMounted(false);
      onDone();
    }, ENTER_ANIMATION_MS + HOLD_MS + LEAVE_ANIMATION_MS);

    return () => {
      clearTimeout(enterTimeout);
      clearTimeout(leaveTimeout);
      clearTimeout(doneTimeout);
    };
  }, [open, onDone]);

  if (!mounted) {
    return null;
  }

  return (
    <div className='eduzz-ui-version-toasty' aria-hidden='true'>
      <img
        src={trexImage}
        alt=''
        className={`eduzz-ui-version-toasty__img eduzz-ui-version-toasty__img--${phase}`}
      />
    </div>
  );
};

export default Toasty;
